import { render, staticRenderFns } from "./ProjectItem.vue?vue&type=template&id=164d70fe&scoped=true"
import script from "./ProjectItem.vue?vue&type=script&lang=ts"
export * from "./ProjectItem.vue?vue&type=script&lang=ts"
import style0 from "./ProjectItem.vue?vue&type=style&index=0&id=164d70fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164d70fe",
  null
  
)

export default component.exports